import React from 'react';
import './LogoTooltip.css';

/**
 * Speech bubble tooltip for the emotional logo
 * Shows explanation of current emotional state
 */
const LogoTooltip = ({ text, isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop for mobile - tap to close */}
      <div className="tooltip-backdrop" onClick={onClose} />
      
      <div className="logo-tooltip-container">
        <div className="logo-tooltip">
          <div className="tooltip-content">
            {text.split('\n').map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
          <div className="tooltip-arrow"></div>
        </div>
      </div>
    </>
  );
};

export default LogoTooltip;

